import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../resources/strings/StringKeys';

const DuplicateFileModal = ({ open, onClose, onAction, fileName }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogTitle>{t(StringKeys.FILE_ALREADY_EXISTS)}</DialogTitle>
      <DialogContent>
        <Typography>
          {t(StringKeys.FILE_X_ALREADY_EXISTS, { x: fileName })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>
          {t(StringKeys.CANCEL)}
        </Button>
        <Button onClick={() => onAction('copy')}>
          {t(StringKeys.SAVE_AS_COPY)}
        </Button>
        <Button 
          onClick={() => onAction('overwrite')}
          color="warning"
        >
          {t(StringKeys.OVERWRITE)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DuplicateFileModal; 